import { render } from "./advenenttable.vue?vue&type=template&id=6761d777&scoped=true"
import script from "./advenenttable.vue?vue&type=script&lang=js"
export * from "./advenenttable.vue?vue&type=script&lang=js"

import "./advenenttable.vue?vue&type=style&index=0&id=6761d777&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6761d777"]])

export default __exports__